import { useEffect } from 'react';

import { getCoreUITokenValues } from '../../../util/theme/fluent9/coreUITokens';
import type { CoreUITokenOverrides } from '../../../util/theme/fluent9/coreUITokens.types';

type UseSetBodyCoreUITokenStyles = (
  isDarkMode: boolean,
  coreuiTokenOverrides: CoreUITokenOverrides | undefined
) => void;

/**
 * Sets CoreUI token values as inline CSS custom properties (variables) directly on the body element.
 * This follows Fluent UI 9's pattern of setting design tokens as inline styles.
 */
export const useSetBodyCoreUITokenStyles: UseSetBodyCoreUITokenStyles = (isDarkMode, coreuiTokenOverrides) => {
  useEffect(() => {
    const tokenValues = getCoreUITokenValues(isDarkMode, coreuiTokenOverrides);

    Object.entries(tokenValues).forEach(([cssVar, value]) => {
      document.body.style.setProperty(cssVar, value);
    });
  }, [isDarkMode, coreuiTokenOverrides]);
};
